var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waf-component roi-component waf-schedule" },
    [
      _vm.has_store_data
        ? _c(
            "div",
            { staticClass: "content-wrap" },
            [
              _c("Breadcrumbs", {
                attrs: {
                  parentRoute: _vm.parentRoute,
                  sequence: [
                    { type: "base", page: "home" },
                    { type: "module", module: _vm.parentRoute },
                  ],
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "waf-head" }, [
                _c("h1", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.translations.scheduleHeading)),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "sports-tabs mt-5" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "waf-body" },
                [
                  _vm.show_schedule_loader
                    ? _c("div", { staticClass: "fg-preloader-wrap" }, [
                        _c("div", { staticClass: "fg-preloader active" }),
                      ])
                    : _vm.seriesList && _vm.seriesList.length
                    ? _c("series-list-box", {
                        attrs: { seriesList: _vm.seriesList },
                      })
                    : _c("no-list", {
                        attrs: {
                          translations: _vm.translations,
                          toShow: "no_series",
                        },
                      }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.totalCount > 0
                ? _c("pagination", {
                    attrs: {
                      currentPage: _vm.page_number,
                      recordsPerView: _vm.pagesize,
                      totalRecords: _vm.totalCount,
                      baseUrl: _vm.getPaginationBaseUrl(),
                      isLoadMoreDisabled: _vm.isLoadMoreDisabled,
                      onPageChange: _vm.onPageChange,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }